import admin from "./admin";
import about from "./about";
import logout from "./logout";
// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [about, admin, logout],
};

export default menuItems;
